<script>
import { Overlay, Tool } from 'trading-vue-js'
import Pin from './primitives/pin.js'
import FixedPinX from './primitives/fixedPinX.js'
import Seg from './primitives/seg.js'
import Ray from './primitives/ray.js'
import { mapActions, mapGetters } from 'vuex'
import ToolSavingMixins from 'Tools/ToolSavingMixins'
import { chartEvents } from "../../chartEvents";
import { debounce } from "../../utils/helper";
import moment from 'moment/moment'
import atr from '../indicators/calculators/atr'
const HIGH = 2
const CLOSE = 4
const LOW = 3

export default {
  name: 'TrailingStopTool',
  mixins: [Overlay, Tool, ToolSavingMixins],

  methods: {
    meta_info() {
      return { author: 'LakshanPerera', version: '1.0.0' }
    },
    tool() {
      return {
        // Descriptor for the tool
        group: 'Measurements',
        type: 'PL',
        hint: 'Price Range',
        data: [], // Default data
        settings: {
          price: true, time: true, showTrailingStop: false,
          isOnChart: false,
          isDialogBoxOpened: false,
          entryPrice: 0,
          stopPrice: 0,
          trailingType: '',
          stepPrice: 0.01,
          riskValueInCash: 50,
          riskValueInPct: 10,
          atrPeriod: 14,
          atrMultiplier: 1,
          undo: 1
        }, // Default settings
      }
    },
    // Called after overlay mounted
    init() {
    //  this.updateSettingsState(this);
      let uuidRef = this.$props?.settings?.$uuid;
      this.localMap = this.keys.map
      delete this.keys.map.Backspace
      delete this.keys.map.Delete
      // this.$emit('object-selected', false)

      //--- dispatch action to show the dialog box

      let text = JSON.stringify(this.$props?.settings);
      let modalSettings = JSON.parse(text)

          if (this.state === 'finished') {
        this.updateSettingsState(this)
        this.pins.push(
          new Pin(this, 'p1', {
            hidden: this.shift,
          })
        )
        this.pins.push(
          new FixedPinX(this, 'p2', {
            state: 'settled',
            hidden: (this.trailingType == '%value' || this.trailingType == 'value') ? true : this.shift,
            isFixedPin: true,
            fixedX: this.p2 ? this.p2[1] : 0,
            fixedTime: this.p2 ? this.p2[0] : this.pins[0].t,
          })
        )
        const parsedStepPrice = parseFloat(modalSettings.stepPrice)
        this.stepValue = isNaN(parsedStepPrice)?0.01 : parsedStepPrice
        // this.stepValue = parseFloat(modalSettings.stepPrice) || 0.01
        this.tGap =
          this.$props.layout.candles[1].raw[0] -
          this.$props.layout.candles[0].raw[0]
        this.registerMouseEvent(this)
        return
      }

      this.pins.push(
        new Pin(this, 'p1', {
          hidden: this.shift,
        })
      )

      // Second one is following mouse until it clicks

      let mousePosition = this.mouse.y$;
      let stopPrice;
      let fixedTime = this.pins[0].t;
      if (mousePosition) {
        let updatedSettings = {
          entryPrice: parseFloat(mousePosition.toFixed(3)),
          isDialogBoxOpened: true,
          isOnChart: true
        }
        let trailingType = modalSettings.trailingType || this.trailingType;
        if (trailingType === 'atr') {
          let atrPeriod = modalSettings.atrPeriod || this.atrPeriod || 14;
          let atrMultiplier = modalSettings.atrMultiplier || this.atrMultiplier || 1;
          let atrVal = 0;
          if (this.multiOhlcv && this.multiOhlcv[this.selectedTab]) {
            const ohlcv = this.multiOhlcv[this.selectedTab];
            const mappedData = ohlcv.map(arr => ({
              date: arr[0],
              open: arr[1],
              high: arr[2],
              low: arr[3],
              close: arr[4],
              volume: arr[5]
            }));
            const atrValues = atr(mappedData, atrPeriod);
            const clickedTime = this.$props.layout.ti_map.i2t(fixedTime);
            const atrEntry = atrValues.find(x => x[0] === clickedTime);
            if (atrEntry) {
              atrVal = atrEntry[1];
            } else {
              const candleIndex = ohlcv.findIndex(arr => arr[0] === clickedTime);
              if (candleIndex !== -1) {
                const match = atrValues.find(x => x[0] === ohlcv[candleIndex][0]);
                if (match) {
                  atrVal = match[1];
                }
              }
            }
          }
          if (atrVal > 0) {
            stopPrice = parseFloat((updatedSettings.entryPrice - (atrVal * atrMultiplier)).toFixed(3));
          } else {
            stopPrice = parseFloat((
              updatedSettings.entryPrice -
              updatedSettings.entryPrice * 0.01
            ).toFixed(3));
          }
        } else {
          stopPrice = parseFloat((
            updatedSettings.entryPrice -
            updatedSettings.entryPrice * 0.01
          ).toFixed(3))
        }
        updatedSettings.stopPrice = stopPrice
        this.$emit("change-settings", updatedSettings);
        modalSettings.startClickTime = this.$props.layout.ti_map.i2t(fixedTime)
        modalSettings = { ...modalSettings, ...updatedSettings }
        chartEvents.$emit('updateTrailingStopModal', modalSettings)

      } else {
        stopPrice = parseFloat(modalSettings.p2?.[1]);

      }

      let fixedX = stopPrice;

      this.pins.push(
        new FixedPinX(this, 'p2', {
          state: 'settled',
          hidden: (this.trailingType == '%value' || this.trailingType == 'value') ? true : this.shift,
          isFixedPin: true,
          fixedX: fixedX,
          fixedTime: fixedTime,
        })
      )

    const parsedStepPrice = parseFloat(modalSettings.stepPrice)
    this.stepValue = isNaN(parsedStepPrice)?0.01 : parsedStepPrice


      // First pin is settled at the mouse position
      this.pins[0].on('settled', () => {
        // this.$emit('change-settings', {
        //   entryPrice: this.pins[0].y$.toFixed(3)
        // })
        // let props = {
        //   stopPrice: parseFloat(this.stopPrice),
        //   stepPrice: this.stepPrice,
        //   entryPrice: parseFloat(this.pins[0].y$.toFixed(3))
        // }
        // this.updatePointsData(props)
      })
      this.pins[1].on('settled', () => {
        // let props = {
        //   stopPrice: parseFloat(this.pins[1].y$.toFixed(3)),
        //   stepPrice: this.stepPrice,
        //   entryPrice: parseFloat(this.entryPrice)
        // }
        // this.updatePointsData(props)
        // this.$emit('change-settings', {          
        //   stopPrice: this.pins[1].y$.toFixed(3)
        // })        
      })
      this.pins[1].y$ = stopPrice
      this.pins[1].y = this.$props.layout.$2screen(this.pins[1].y$)
      this.pins[1].x = fixedX
      this.pins[1].t = fixedTime

      this.pins[1].update_settings('p2', this.$props.cursor.t, this.pins[1].y$)
      // end drawing mode
      this.set_state('finished')
      this.$emit('drawing-mode-off')
      // Deselect the tool in shiftMode
      /*if (this.shift) {
        this._$emit('custom-event', {
          event: 'object-selected',
          args: [],
        })
      }*/

      this.tGap =
        this.$props.layout.candles[1].raw[0] -
        this.$props.layout.candles[0].raw[0]
      // this.pins[0].update()
      // this.pins[1].update()
      this.registerMouseEvent(this)
    },
    draw(ctx) {
      if (this.$props.layout?.ti_map) {
        if (this.p1 && this.p1[2] !== undefined) {
          const rawT2i = this.$props.layout.ti_map.t2i(this.p1[2]);
          if (Number.isNaN(rawT2i) || rawT2i < 0) {
            return; // Exit early to prevent saving invalid coordinates
          }
        }
          const fullCandles = this.multiOhlcv && this.multiOhlcv[this.selectedTab] ? this.multiOhlcv[this.selectedTab] : [];
          const layoutCandles = this.$props.layout.candles;
        // let currentTGap = 86400000;
        if (layoutCandles && layoutCandles.length > 1) {
         let currentTGap = layoutCandles[1].raw[0] - layoutCandles[0].raw[0];
        } else if (fullCandles && fullCandles.length > 1) {
          currentTGap = fullCandles[1][0] - fullCandles[0][0];
        }
          const isIntraday = this.timeFrame && !['D', 'W', 'M', 'DAY', 'WEEK', 'MONTH'].includes(this.timeFrame.toUpperCase());// true only for intraday timeframes (H4, H2, H1, etc.)
        if (this.p1 && this.p1[2] !== undefined) {
          // const correctIndex = Math.floor(this.$props.layout.ti_map.t2i(this.p1[2]));
        const targetTime = typeof this.p2[2] === 'number' 
            ? this.p2[2] 
            : moment(this.p2[2], ['DD-MM-YYYY HH:mm', 'YYYY-MM-DDTHH:mm', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD']).valueOf();
          const rawT2i = this.$props.layout.ti_map.t2i(targetTime);
          let correctIndex = Math.floor(rawT2i);

          if (isIntraday && correctIndex >= 0 && correctIndex < fullCandles.length) {
            // const candleDateStr = moment(fullCandles[correctIndex][0]).format('YYYY-MM-DD');
            // const targetDateStr = moment(this.p1[2]).format('YYYY-MM-DD');
            // const candleDateStr = moment.utc(fullCandles[correctIndex][0]).format('YYYY-MM-DD');
            // const targetDateStr = moment.utc(this.p1[2]).format('YYYY-MM-DD');

            // // If mapped to a previous day's close due to overnight/weekend gaps, snap to first candle of the target day
            // if (candleDateStr < targetDateStr) {
            //   // const nextCandleIdx = fullCandles.findIndex(arr => moment(arr[0]).format('YYYY-MM-DD') >= targetDateStr);
            //   const nextCandleIdx = fullCandles.findIndex(arr => moment.utc(arr[0]).format('YYYY-MM-DD') >= targetDateStr);
              if (fullCandles[correctIndex][0] < this.p2[2]) {
             const nextCandleIdx = fullCandles.findIndex(arr => arr[0] >= this.p2[2]);
              if (nextCandleIdx !== -1) {
                correctIndex = Math.floor(this.$props.layout.ti_map.t2i(fullCandles[nextCandleIdx][0]));
              }
            }
          }
          if (this.p1[0] !== correctIndex) {
            this.p1[0] = correctIndex;
            if (this.pins && this.pins[0]) this.pins[0].re_init();
          }
        }
        if (this.p2 && this.p2[2] !== undefined) {
          // const correctIndex = Math.floor(this.$props.layout.ti_map.t2i(this.p2[2]));
            const targetTime = typeof this.p1[2] === 'number' 
            ? this.p1[2] 
            : moment(this.p1[2], ['DD-MM-YYYY HH:mm', 'YYYY-MM-DDTHH:mm', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD']).valueOf();
          const rawT2i = this.$props.layout.ti_map.t2i(targetTime);
          //  const rawT2i = this.$props.layout.ti_map.t2i(this.p2[2]);
          let correctIndex = Math.floor(rawT2i);

          if (isIntraday && correctIndex >= 0 && correctIndex < fullCandles.length) {
            // const candleDateStr = moment(fullCandles[correctIndex][0]).format('YYYY-MM-DD');
            // const targetDateStr = moment(this.p2[2]).format('YYYY-MM-DD');
          //   const candleDateStr = moment.utc(fullCandles[correctIndex][0]).format('YYYY-MM-DD');
          //   const targetDateStr = moment.utc(this.p2[2]).format('YYYY-MM-DD');

          //   // Align p2 stop pin identically to p1
          //  if (candleDateStr < targetDateStr) {
          //     // const nextCandleIdx = fullCandles.findIndex(arr => moment(arr[0]).format('YYYY-MM-DD') >= targetDateStr);
          //       const nextCandleIdx = fullCandles.findIndex(arr => moment(arr[0]).format('YYYY-MM-DD') >= targetDateStr);
          if (fullCandles[correctIndex][0] < this.p1[2]) {
              const nextCandleIdx = fullCandles.findIndex(arr => arr[0] >= this.p1[2]);
              if (nextCandleIdx !== -1) {
                correctIndex = Math.floor(this.$props.layout.ti_map.t2i(fullCandles[nextCandleIdx][0]));
              }
            }
          }
          if (this.p2[0] !== correctIndex) {
            this.p2[0] = correctIndex;
            if (this.pins && this.pins[1]) this.pins[1].re_init();
          }
        }
      }
      if (!this.p1 || !this.p2) return
      const layout = this.$props.layout
      ctx.lineWidth = this.line_width
      ctx.strokeStyle = this.color
      ctx.globalAlpha = 1

      ctx.beginPath()
      ctx.strokeStyle = '#23a776'
      this.pins[1].t = this.p1[0]
      new Ray(this, ctx).draw(this.p1, [this.p1[0] + this.tGap, this.p1[1]])
      ctx.stroke()

      ctx.globalAlpha = 0
      new Seg(this, ctx).draw(this.p1, this.p2)
      ctx.stroke()
      ctx.globalAlpha = 1

      // 1. Get the full historical candle array
      const fullCandles = this.multiOhlcv && this.multiOhlcv[this.selectedTab] ? this.multiOhlcv[this.selectedTab] : [];
      if (!fullCandles.length || !layout.ti_map) return;

      // 2. Precompute the ATR values ONCE per render frame
      let atrValues = [];
      let toolMultiplier = 1;
      if (this.trailingType === 'atr') {
        const recalcPeriod = parseInt(this.atrPeriod) || 14;
        toolMultiplier = parseFloat(this.atrMultiplier) || 1;

        const mappedData = fullCandles.map(arr => ({
          date: arr[0],
          open: arr[1],
          high: arr[2],
          low: arr[3],
          close: arr[4],
          volume: arr[5]
        }));
        atrValues = atr(mappedData, recalcPeriod);
      }

      // 3. Pre-calculate trailing stop values over the entire history starting from placement index
      const trailingMap = {};
      const entryIndex = this.p1[0];

      if (this.trailingType == 'atr') {
        let first = true;
        let checkAtr = 0;
        let calculatedStartStopPrice = 0;
        for (let i = 0; i < fullCandles.length; i++) {
          const candle = fullCandles[i];
          const idx = Math.round(layout.ti_map.t2i(candle[0]));
          if (idx < entryIndex) continue;

          // Find the ATR value and apply the dialog box multiplier
          const atrEntry = atrValues.find(x => x[0] === candle[0]);
          const rawAtrVal = atrEntry ? atrEntry[1] : 0;
          const atrVal = rawAtrVal * toolMultiplier; // Multiplier applied here

          if (first) {
            // checkAtr = (this.p2 && this.p2[1]) ? this.p2[1] : (candle[CLOSE] - atrVal);
            // first = false;
            calculatedStartStopPrice = parseFloat((this.entryPrice - atrVal).toFixed(3));
            checkAtr = calculatedStartStopPrice;
            first = false;
          } else {
            checkAtr = checkAtr > candle[CLOSE] - atrVal ? checkAtr : candle[CLOSE] - atrVal;
          }
          trailingMap[idx] = checkAtr;
        }
        if (this.p2 && calculatedStartStopPrice > 0 && this.p2[1] !== calculatedStartStopPrice) {
          this.p2[1] = calculatedStartStopPrice;
          this.sett.stopPrice = calculatedStartStopPrice;
          if (this.pins && this.pins[1]) {
            this.pins[1].y$ = calculatedStartStopPrice;
            this.pins[1].re_init();
          }
        }
      } 
      else if (this.trailingType == 'value') {
        let entryPrice = this.p1[1];
        let lastHighestPoint = entryPrice;
        let dollerVal = this.riskValueInCash;
        for (let i = 0; i < fullCandles.length; i++) {
          const candle = fullCandles[i];
          const idx = Math.round(layout.ti_map.t2i(candle[0]));
          if (idx < entryIndex) continue;

          if (candle[HIGH] > lastHighestPoint) {
            lastHighestPoint = candle[HIGH];
          }
          let stopVal = lastHighestPoint - dollerVal;
          trailingMap[idx] = stopVal;
        }
      } 
      else if (this.trailingType == '%value') {
        let entryPrice = this.p1[1];
        let lastHighestPoint = entryPrice;
        let percentValue = (1 - this.riskValueInPct / 100);
        for (let i = 0; i < fullCandles.length; i++) {
          const candle = fullCandles[i];
          const idx = Math.round(layout.ti_map.t2i(candle[0]));
          if (idx < entryIndex) continue;

          if (candle[HIGH] > lastHighestPoint) {
            lastHighestPoint = candle[HIGH];
          }
          let stopVal = lastHighestPoint * percentValue;
          trailingMap[idx] = stopVal;
        }
      } 
      else { // step-price
        let entryPrice = this.p1[1];
        let lastHighestPoint = entryPrice;
        let lastSLPosition = this.p2[1];
        let first = true;
        let lastAdjustmentPrice = entryPrice;
        for (let i = 0; i < fullCandles.length; i++) {
          const candle = fullCandles[i];
          const idx = Math.round(layout.ti_map.t2i(candle[0]));
          if (idx < entryIndex) continue;

          if (first) {
            lastHighestPoint = candle[HIGH];
            first = false;
            trailingMap[idx] = lastSLPosition;
            continue;
          }
          if (candle[HIGH] > lastHighestPoint) {
            lastHighestPoint = candle[HIGH];
          }

          // Only trail the stop when price has risen by at least stepValue
          // from the last adjustment level
          while (this.stepValue> 0 && lastHighestPoint >= lastAdjustmentPrice + this.stepValue) {
            lastSLPosition += this.stepValue;
            lastAdjustmentPrice += this.stepValue;
          }
          trailingMap[idx] = lastSLPosition;
        }
      }

      // 4. Draw only the visible viewport candles by looking up values in trailingMap
      const candles = this.$props.layout.candles;
      ctx.beginPath();
      ctx.strokeStyle = 'red';
      let currentColor = 'red';
      let triggered = false;
      let lastPosition = null;
      const entryPrice = this.p1[1];

      for (let i = 0; i < candles.length; i++) {
        const candle = candles[i];
        if (candle.raw[0] < entryIndex) continue;

        const nextCandle = candles[i + 1] ? candles[i + 1] : null;
        const pointWithNext = nextCandle?.x ? nextCandle.x : candle.x + candle.w;
        const currentSL = trailingMap[candle.raw[0]]; // candle.raw[0] is the index

        if (currentSL === undefined) continue;

        if (!lastPosition) {
          ctx.moveTo(candle.x, layout.$2screen(currentSL));
          ctx.lineTo(pointWithNext, layout.$2screen(currentSL));
          lastPosition = { x: pointWithNext, y: layout.$2screen(currentSL) };
          continue;
        }

        if (!triggered && candle.raw[CLOSE] < currentSL) {
          triggered = true;
        }

        let targetColor = 'red';
        if (triggered) {
          targetColor = 'red';
        } else if (currentSL > entryPrice) {
          targetColor = 'green';
        } else {
          targetColor = 'red';
        }

        if (targetColor !== currentColor && lastPosition) {
          ctx.stroke();
          ctx.beginPath();
          ctx.strokeStyle = targetColor;
          ctx.moveTo(lastPosition.x, lastPosition.y);
          currentColor = targetColor;
        }

        ctx.lineTo(candle.x, layout.$2screen(currentSL));
        ctx.lineTo(pointWithNext, layout.$2screen(currentSL));
        lastPosition = { x: pointWithNext, y: layout.$2screen(currentSL) };
      }
      ctx.stroke();

      this.render_pins(ctx);
    }

,

    calc() {
      return {
        props: {
          atrPeriod: { def: 15, text: 'atrPeriod' },
          atrMultiplier: { def: 1, text: 'atrMultiplier' },
        },
        conf: { renderer: 'Spline' },
        update: `
                    return (atr(atrPeriod)[0]* atrMultiplier)
                `
      }
    },
    use_for() {
      return ['TrailingStopTool']
    },
    data_colors() {
      return [this.color]
    },
    updatePointsData(props) {
      let { stopPrice, stepPrice, entryPrice, trailingType, atrPeriod, atrMultiplier, riskValueInPct, riskValueInCash, periodStartDate } = props
      if (trailingType == '%value' || trailingType == 'value') {
        this.pins[1].hidden = true
      }
      else {
        this.pins[1].hidden = false
      }
      stepPrice = parseFloat(stepPrice)
      stopPrice = parseFloat(stopPrice)
      entryPrice = parseFloat(entryPrice)

      // Recalculate stopPrice when trailingType is 'atr' using new period/multiplier
      // if (trailingType === 'atr') {
      //   let recalcPeriod = atrPeriod || 14;
      //   let recalcMultiplier = atrMultiplier || 5;
      //   let atrVal = 0;
      //   if (this.multiOhlcv && this.multiOhlcv[this.selectedTab]) {
      //     const ohlcv = this.multiOhlcv[this.selectedTab];
      //     const mappedData = ohlcv.map(arr => ({
      //       date: arr[0],
      //       open: arr[1],
      //       high: arr[2],
      //       low: arr[3],
      //       close: arr[4],
      //       volume: arr[5]
      //     }));
      //     const atrValues = atr(mappedData, recalcPeriod);
      //     // Use the pin's current time position to find the matching ATR value
      //     const pinTime = this.$props.layout.ti_map.i2t(this.p1[0]);
      //     const atrEntry = atrValues.find(x => x[0] === pinTime);
      //     if (atrEntry) {
      //       atrVal = atrEntry[1];
      //     } else {
      //       const candleIndex = ohlcv.findIndex(arr => arr[0] === pinTime);
      //       if (candleIndex !== -1) {
      //         const match = atrValues.find(x => x[0] === ohlcv[candleIndex][0]);
      //         if (match) {
      //           atrVal = match[1];
      //         }
      //       }
      //     }
      //     // If no exact match found, use the last available ATR value
      //     if (atrVal === 0 && atrValues.length > 0) {
      //       atrVal = atrValues[atrValues.length - 1][1];
      //     }
      //   }
      //   if (atrVal > 0) {
      //     stopPrice = parseFloat((entryPrice - (atrVal * recalcMultiplier)).toFixed(3));
      //   }
      // }

      this.stepValue = stepPrice
      if (!this.pins[0]) return
      this.pins[0].y$ = entryPrice
      this.pins[0].y = this.$props.layout.$2screen(this.pins[0].y$)
      let timeStamp = this.$props.layout.ti_map.i2t(this.p1[0])


      if (!this.pins[1] || !stopPrice) return
      this.pins[1].y$ = stopPrice
      this.pins[1].y = this.$props.layout.$2screen(stopPrice)
      // if (moment(timeStamp).format('YYYY-MM-DD').toString() != moment(periodStartDate).format('YYYY-MM-DD').toString()) {
       const currentSavedDate = this.p1?.[2] || this.sett.startClickTime;
       const isIntraday = this.timeFrame && !['D', 'W', 'M', 'DAY', 'WEEK', 'MONTH'].includes(this.timeFrame.toUpperCase());
       const formatStr = isIntraday ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
      if (moment(currentSavedDate).format(formatStr).toString() != moment(periodStartDate).format(formatStr).toString()) {

        let xVal = Math.floor(this.$props.layout.ti_map.t2i(periodStartDate))
        let timeVal = this.$props.layout.ti_map.i2t(xVal)

        this.pins[0].t = xVal
        this.pins[1].t = xVal
        this.$emit('change-settings', {
          // p1: [this.pins[0].t, this.pins[0].y$, timeVal],
          // p2: [this.pins[0].t, stopPrice, timeVal],
          p1: [this.pins[0].t, this.pins[0].y$, periodStartDate],
          p2: [this.pins[0].t, stopPrice, periodStartDate],
          stepPrice: stepPrice,
          stopPrice: stopPrice,
          entryPrice: entryPrice,
          atrMultiplier: atrMultiplier,
          atrPeriod: atrPeriod,
          trailingType: trailingType,
          riskValueInPct: riskValueInPct,
          riskValueInCash: riskValueInCash
        });
        // Force save after settings update
        this.$nextTick(() => this.saveSettings(this));
      }
      else {

        this.$emit('change-settings', {
          p1: [this.p1[0], this.pins[0].y$, this.p1?.[2] || this.sett.startClickTime],
          p2: [this.p1[0], stopPrice, this.p1?.[2] || this.sett.startClickTime],
          stepPrice: stepPrice,
          stopPrice: stopPrice,
          entryPrice: entryPrice,
          atrMultiplier: atrMultiplier,
          atrPeriod: atrPeriod,
          trailingType: trailingType,
          riskValueInPct: riskValueInPct,
          riskValueInCash: riskValueInCash
        });
        // Force save after settings update
        this.$nextTick(() => this.saveSettings(this));
      }
      this.saveSettings(this)

    },
    ...mapActions('action', ['saveUndoAction'])
  },
  // Define internal setting & constants here
  computed: {
    ...mapGetters([
      'themePrimaryColor',
      'themeSecondaryColor',
      'themeFontColor',
      'dc',
      'getStopToolsDefaultValues',
      'multiOhlcv',
      'selectedTab'
    ]),
    ...mapGetters('action', [
      'currentUndoValue',
      'currentRef'
    ]),
      offchartList() {
      return this.dc?.data?.offchart;
    },
    undo() {
      return this.$props.settings.undo
    },
    sett() {
      return this.$props.settings
    },
    p1() {
      return this.$props.settings.p1
    },
    p2() {
      return this.$props.settings.p2
    },
    line_width() {
      return this.sett.lineWidth || 2
    },
    color() {
      return this.sett.color || this.$props.colors.cross
    },
    back_color() {
      return this.sett.backColor || '#9b9ba316'
    },
    value_back() {
      return this.sett.valueBack || '#9b9ba316'
    },
    value_color() {
      return this.sett.valueColor || this.$props.colors.text
    },
    isDialogBoxOpened() {
      return this.sett.isDialogBoxOpened || false
    },
    stopPrice() {
      return this.sett.stopPrice || 0
    },
    entryPrice() {
      return this.sett.entryPrice || 0
    },
    trailingType() {
      return this.sett.trailingType || 'step-price'
    },
    stepPrice() {
       return (this.sett.stepPrice !== undefined && this.sett.stepPrice !== null) ? this.sett.stepPrice : 0.01
    },
    riskValueInCash() {
      return this.sett.riskValueInCash || 50
    },
    riskValueInPct() {
      return this.sett.riskValueInPct || 10
    },
    atrPeriod() {
      return parseInt(this.sett.atrPeriod) || 14
    },
    atrMultiplier() {
      return parseFloat(this.sett.atrMultiplier) || 1
    },
    prec() {
      return this.sett.precision || 2
    },
    new_font() {
      return '12px ' + this.$props.font.split('px').pop()
    },
    price() {
      return 'price' in this.sett ? this.sett.price : true
    },
    time() {
      return 'time' in this.sett ? this.sett.time : false
    },
    shift() {
      return this.sett.shiftMode
    },
  },
  watch: {
     offchartList: {
      handler(newVal) {
        // When indicators list changes, recalculate stop loss levels to keep the circle in sync
        this.updatePointsData({
          stopPrice: this.stopPrice,
          stepPrice: this.stepPrice,
          entryPrice: this.entryPrice,
          trailingType: this.trailingType,
          atrPeriod: this.atrPeriod,
          atrMultiplier: this.atrMultiplier,
          riskValueInPct: this.riskValueInPct,
          riskValueInCash: this.riskValueInCash,
          periodStartDate: this.p1?.[2] || this.sett.startClickTime
        });
      },
      deep: true
    },
    undo(newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.$props.settings?.$uuid == this.currentRef?.drawingRef) {
          this.pins.forEach((x, i) => x.update_from(
            this.currentUndoValue[x.name], true
          ))
          this.$nextTick(debounce(() => {
            this.saveUndoAction({
              chartIndex: this.currentRef?.chartIndex,
              val: this.currentRef?.drawingRef,
              data: this.currentUndoValue
            })
          }))
        }
      }
    },

  },
  data() {
    return {
      localMap: null
    }
  },
  mounted() {
    let event = 'UpdateTrailingStopSettings' + this.sett?.$uuid;
    // let event = 'UpdateTrailingStopSettings';
    chartEvents.$on(event, this.updatePointsData)
  },
  beforeDestroy() {
    let event = 'UpdateTrailingStopSettings' + this.sett?.$uuid;
    // let event = 'UpdateTrailingStopSettings';
    chartEvents.$off(event)
  },
  created() {

     if (
      this.getStopToolsDefaultValues && 
      !this.$props.settings.isDialogBoxOpened &&
      !this.$props.settings.p1 // <-- Ensure settings are not overridden if tool is already placed
    ) {
      Object.assign(this.$props.settings || {}, this.getStopToolsDefaultValues)
    }
    this.updateSettingsState(this);
  }
}
</script>
